import React, { useState, useEffect, useRef } from "react";
import { Modal } from "reactstrap";
import background from "./background.png";
import arrow from "./arrow.png";
import styled from "styled-components";
import { connect } from "react-redux";
import _ from "lodash";

const FlipModal = (props) => {
  let gameState = _.get(props, "gameReducer.roomObj.game_state");
  let prompt = _.get(gameState, "prompt");
  let ques = prompt?.replace(/\[BLANK]/g, "________");
  const playedCards = _.get(gameState, "played_cards");
  const prevPlayedCards = useRef(null);
  const [flippedCard, setFlippedCard] = useState(null);

  useEffect(() => {
    if (prevPlayedCards?.current) {
      const prevPlayerHand = prevPlayedCards.current;
      const newPlayerHand = playedCards;
      if (JSON.stringify(prevPlayerHand) === JSON.stringify(newPlayerHand)) return;
      else {
        prevPlayerHand.map((item) => {
          newPlayerHand.map((element) => {
            if (element.card.id === item.card.id && element.flipped !== item.flipped) {
              setFlippedCard(element);
            }
          });
        });
      }
    }
    prevPlayedCards.current = playedCards;
  }, [playedCards]);

  return (
    <MainModal className="dw20-game-modal" image={background} isOpen={true} centered backdrop={false}>
      <div className="card-wrapper">
        <div className="view-card card-left">
          <span className="hash-tag-code">#DoneWith2020</span>
          <p >{ques}</p>
        </div>
        <img className="arrow" src={arrow} />
        <div className="view-card card-right largeText">
          {flippedCard !== null && <span className="hash-tag-code">#DoneWith2020</span>}
          {/* <p>{flippedCard !== null ? flippedCard.card.text : 'DoneWith2020'}</p> */}
          {flippedCard !== null ? (
            <p className = "dw-card-text" >{flippedCard.card.text}</p>
          ) : (
            <p>
              DONE
              <br />
              WITH
              <br />
              2020
            </p>
          )}
        </div>
      </div>
    </MainModal>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(FlipModal);

const MainModal = styled(Modal)`
  .modal-content {
    background-image: url(${({ image }) => image});
  }
`;
